// DiscordIcon.tsx
import React from "react";

/**
 * Composant pour afficher l'icône Discord
 * 
 * @param className - classes optionnelles pour styliser l'icône (tailwind, etc.)
 */
export function DiscordIcon({ className }: { className?: string }) {
  return (
    <img
      src="/discord-icon.webp"  // Assurez-vous que l'image est dans /public/discord-icon.webp
      alt="Discord Icon"
      className={className}
    />
  );
}
